<style>
  .el-input__inner{
    text-align: right;
  }
</style>
<template>
  <div
    class="modal fade"
    id="margin_modal"
    tabindex="-1"
    aria-hidden="true"
    ref="setPricePartnerModalRef"
  >
    <!--begin::Modal dialog-->
    <div class="modal-dialog modal-dialog-centered mw-700px">
      <!--begin::Modal content-->
      <div class="modal-content">
        <!--begin::Modal header-->
        <div class="modal-header" id="kt_modal_set_price_partner_header">
          <!--begin::Modal title-->
          <h2 class="fw-bolder">กำหนดราคา</h2>
          <!--end::Modal title-->

          <!--begin::Close-->
          <div
            id="kt_modal_set_price_partner_close"
            @click="hide"
            class="btn btn-icon btn-sm btn-active-icon-primary"
          >
            <span class="svg-icon svg-icon-1">
              <inline-svg src="/media/icons/duotune/arrows/arr061.svg" />
            </span>
          </div>
          <!--end::Close-->
        </div>
        <!--end::Modal header-->
        <!--begin::Modal body-->
        <el-form :model="formModel" :rules="rules" ref="setPricePartnerForm">
          <div class="modal-body py-5 px-lg-10">
            <!--begin::Scroll-->
            <div
              class="scroll-y me-n7 pe-7"
              id="kt_modal_set_price_partner_scroll"
              data-kt-scroll="true"
              data-kt-scroll-activate="{default: false, lg: true}"
              data-kt-scroll-max-height="auto"
              data-kt-scroll-dependencies="#kt_modal_set_price_partner_header"
              data-kt-scroll-wrappers="#kt_modal_set_price_partner_scroll"
              data-kt-scroll-offset="300px"
            >
              <div class="row">
                <div class="col-4" style="border-right: 1px solid rgb(226 227 229)">
                  <div class="row">
                    <h3><el-checkbox v-model="checkedCustom" @click="checked('custom')"></el-checkbox> กำหนดเอง</h3>
                  </div>
                  <br>
                  <div class="row g-9 mb-7">
                    <!--begin::Col-->
                    <div class="col-md-12 fv-row">
                      <!--begin::Label-->
                      <label class="fs-6 fw-bold mb-2">ราคา</label>&nbsp;
                      <!--end::Label-->

                      <!--begin::Input-->
                        <el-input v-model="formModel.priceCustom" style="width: 35%; text-align: right;" :disabled="customDisabled" />
                        <span style="color: #909399"> บ./กก.</span>
                      <!--end::Input-->
                    </div>
                    <!--end::Col-->
                  </div>
                </div>
                <div class="col-8">
                  <div class="row">
                    <h3><el-checkbox v-model="checkedDealer" @click="checked('dealer')"></el-checkbox> กำหนดจากราคา Dealer</h3>
                  </div>  
                  <br>                
                  <div>
                            <div class="row">
                                <div class="col-12">
                                    <el-radio-group v-model="filter.status" :disabled="dealerFilterDisabled">
                                        <el-radio-button v-for="s in status" :key="s.value" :label="s.name" @click="clickFilterDealer(s.value)"></el-radio-button>
                                    </el-radio-group> 
                                    &nbsp;&nbsp;
                                    <el-input v-model="formModel.priceDealer" style="width: 20%; text-align: right;" :disabled="dealerInputDisabled" />
                                    <span style="color: #909399"> บ./กก.</span>
                                </div>
                            </div>                    
                  </div>
                </div>
              </div>
            </div>
            <!--end::Scroll-->
          </div>
          <!--end::Modal body-->
        </el-form>
        <div class="modal-footer" style="padding: 0.5rem">
            <button
              class="btn btn-light-primary me-3"
              type="reset"
              @click="hide"
            >
              กลับ
            </button>
            <button class="btn btn-primary me-3" @click="submit">บันทึก</button>
        </div>
      </div>
      <!--begin::Modal content-->
    </div>
    <!--begin::Modal dialog-->
  </div>
</template>

<script>
import { Modal } from "bootstrap";
import Swal from "sweetalert2/dist/sweetalert2.js";
import ApiService from "@/core/services/ApiService";

export default {
  data() {
    return {
      formModel: {
        priceCustom: null,
        priceDealer: null,
      },
      rules: {
        price: [{ required: true, message: "กรุณาระบุราคา" }],
      },
      setPricePartnerModalRef: null,
      products: [],
            filter: {
                status: 'Add',
            },       
      status: [
        { value: "Add", name: 'บวก'},
        { value: "Dealer", name: 'ราคาดีลเลอร์'},
        { value: "Del", name: 'ลบ'},
      ],
      radio: '',   
      conditon: '',  
      checkedCustom: false,
      checkedDealer: false,
      customDisabled: true,
      dealerFilterDisabled: true,
      dealerInputDisabled: true,
    };
  },
  mounted() {
    this.setPricePartnerModalRef = new Modal(
      this.$refs.setPricePartnerModalRef
    );
    this.checkedCustom = false;
    this.checkedDealer = false;  
  },
  methods: {
    hide() {
      this.products = [];
      this.setPricePartnerModalRef.hide();
    },
    show(products) {
      this.checkedCustom = false;
      this.checkedDealer = false;   
      this.customDisabled = true,
      this.dealerFilterDisabled = true,    
      this.dealerInputDisabled = true,         
      this.products = products;
      this.formModel.priceCustom = null;
      this.formModel.priceDealer = null;
      this.filter.status = '';
      // this.$refs.setPricePartnerForm.resetFields();
      this.setPricePartnerModalRef.show();
    },
    submit: async function () {
      this.$refs.setPricePartnerForm.validate(async (valid) => {
        if (!valid) return;

        if(this.checkedCustom == true)
        {
          this.submitCustom();
        }
        else if(this.checkedDealer == true)
        {
          this.submitDealer();
          // console.log(this.products);
        }

      });
    },
    submitCustom: async function(){
        const priceNotInCondition = this.products.filter(
            (data) => this.formModel.priceCustom < data.priceLower || this.formModel.priceCustom > data.priceLimit
        );        

        if(priceNotInCondition == 0){
          const loader = this.$loading.show();
          try {
            const productKeys = this.products
              .map((data) => data.productID + "|" + this.formModel.priceCustom+ "|" +data.branchID)
              .join(",");

            const { data } = await ApiService.post(
              "partners/UpdatePricePartner",
              {
                Products: productKeys,
              }
            );

            loader.hide();

            Swal.fire({
              title: "บันทึกสำเร็จ",
              icon: "success",
              showCancelButton: false,
              showConfirmButton: false,                  
              allowOutsideClick: false,
              timer: 1500,
            }).then(() => {
              this.formModel.priceCustom = null;
              this.$emit("refreshdata");
              this.hide();
            });
          } catch (error) {
            console.log(error);
            Swal.fire({
              title: "Error",
              icon: "error",
              text: error.response.data,
              allowOutsideClick: false,
            });
          } finally {
            loader.hide();
          }
        }
        else
        {
                Swal.fire({
                        text: "ราคาต่ำสุด = " + priceNotInCondition[0].priceLower + " บ./กก. และราคาสูงสุด = " + priceNotInCondition[0].priceLimit + " บ./กก." ,
                        icon: "warning",
                        buttonsStyling: false,
                        confirmButtonText: "ปิด",
                        allowOutsideClick: false,
                        customClass: {
                            confirmButton: "btn btn-primary",
                        },
                });
        }
    },
    submitDealer: async function(){      

      if(this.filter.status == "บวก")
      {
        const priceNotInCondition = this.products.filter(
            (data) => (data.priceDealer+Number(this.formModel.priceDealer)) < data.priceLower || (data.priceDealer+Number(this.formModel.priceDealer)) > data.priceLimit
        ); 

              const productKeys1 = this.products
                .map((data) => data.productID + "|" + (data.priceDealer + Number(this.formModel.priceDealer))+ "|" +data.branchID)
                .join(",");     
                
        if(priceNotInCondition.length == 0){
          const loader = this.$loading.show();
          try {
            
            const { data } = await ApiService.post(
              "partners/UpdatePricePartner",
              {
                Products: productKeys1,
              }
            );

            loader.hide();

            Swal.fire({
              title: "บันทึกสำเร็จ",
              icon: "success",
              showCancelButton: false,
              showConfirmButton: false,                  
              allowOutsideClick: false,
              timer: 1500,
            }).then(() => {
              this.formModel.priceCustom = null;
              this.$emit("refreshdata");
              this.hide();
            });
          } catch (error) {
            console.log(error);
            Swal.fire({
              title: "Error",
              icon: "error",
              text: error.response.data,
              allowOutsideClick: false,
            });
          } finally {
            loader.hide();
          }
        }
        else
        {
                Swal.fire({
                        text: "ราคาต่ำสุด = " + priceNotInCondition[0].priceLower + " บ./กก. และราคาสูงสุด = " + priceNotInCondition[0].priceLimit + " บ./กก." ,
                        icon: "warning",
                        buttonsStyling: false,
                        confirmButtonText: "ปิด",
                        allowOutsideClick: false,
                        customClass: {
                            confirmButton: "btn btn-primary",
                        },
                });
        }                 
      }
      else if(this.filter.status == "ลบ")
      {
        const priceNotInCondition = this.products.filter(
            (data) => (data.priceDealer-this.formModel.priceDealer) < data.priceLower || (data.priceDealer-this.formModel.priceDealer) > data.priceLimit
        ); 

              const productKeys1 = this.products
                .map((data) => data.productID + "|" + (data.priceDealer - this.formModel.priceDealer)+ "|" +data.branchID)
                .join(",");     
                
        if(priceNotInCondition.length == 0){
          const loader = this.$loading.show();
          try {
            
            const { data } = await ApiService.post(
              "partners/UpdatePricePartner",
              {
                Products: productKeys1,
              }
            );

            loader.hide();

            Swal.fire({
              title: "บันทึกสำเร็จ",
              icon: "success",
              showCancelButton: false,
              showConfirmButton: false,                  
              allowOutsideClick: false,
              timer: 1500,
            }).then(() => {
              this.formModel.priceDealer = null;
              this.filter.status = "";
              this.$emit("refreshdata");
              this.hide();
            });
          } catch (error) {
            console.log(error);
            Swal.fire({
              title: "Error",
              icon: "error",
              text: error.response.data,
              allowOutsideClick: false,
            });
          } finally {
            loader.hide();
          }
        }
        else
        {
                Swal.fire({
                        text: "ราคาต่ำสุด = " + priceNotInCondition[0].priceLower + " บ./กก. และราคาสูงสุด = " + priceNotInCondition[0].priceLimit + " บ./กก." ,
                        icon: "warning",
                        buttonsStyling: false,
                        confirmButtonText: "ปิด",
                        allowOutsideClick: false,
                        customClass: {
                            confirmButton: "btn btn-primary",
                        },
                });
        } 
      } 
      else if(this.filter.status == "ราคาดีลเลอร์")
      {
       const priceNotInCondition = this.products.filter(
            (data) => data.priceDealer < data.priceLower || data.priceDealer > data.priceLimit
        ); 

        const productKeys1 = this.products
          .map((data) => data.productID + "|" + data.priceDealer+ "|" +data.branchID)
          .join(",");     
                
        if(priceNotInCondition.length == 0){
          const loader = this.$loading.show();
          try {
            
            const { data } = await ApiService.post(
              "partners/UpdatePricePartner",
              {
                Products: productKeys1,
              }
            );

            loader.hide();

            Swal.fire({
              title: "บันทึกสำเร็จ",
              icon: "success",
              showCancelButton: false,
              showConfirmButton: false,                  
              allowOutsideClick: false,
              timer: 1500,
            }).then(() => {
              this.formModel.priceCustom = null;
              this.$emit("refreshdata");
              this.hide();
            });
          } catch (error) {
            console.log(error);
            Swal.fire({
              title: "Error",
              icon: "error",
              text: error.response.data,
              allowOutsideClick: false,
            });
          } finally {
            loader.hide();
          }
        }
        else
        {
                Swal.fire({
                        text: "ราคาต่ำสุด = " + priceNotInCondition[0].priceLower + " บ./กก. และราคาสูงสุด = " + priceNotInCondition[0].priceLimit + " บ./กก." ,
                        icon: "warning",
                        buttonsStyling: false,
                        confirmButtonText: "ปิด",
                        allowOutsideClick: false,
                        customClass: {
                            confirmButton: "btn btn-primary",
                        },
                });
        } 
      }        
    },
    checked(e){
      if(e == "custom")
      {
        this.checkedDealer = false;
        this.dealerFilterDisabled = true;
        this.dealerInputDisabled = true;
        this.customDisabled = false;
        this.formModel.priceDealer = null;
        this.filter.status = '';
      }
      else if(e == "dealer")
      {
        this.checkedCustom = false;
        this.customDisabled = true;
        this.dealerFilterDisabled = false;
        this.dealerInputDisabled = false;
        this.formModel.priceCustom = null;
      }
    },
    clickFilterDealer(e){
      if(e == "Dealer"){
        this.dealerInputDisabled = true;        
        this.formModel.priceDealer = null;
      }else{
        this.dealerInputDisabled = false;        
      }
    }
  },
};
</script>
